module.exports = __webpack_public_path__ + "img/ECU_for_Nissan_Leaf.45284488.jpg";